export default __webpack_public_path__ + "static/media/unauth.601c50c3.svg";